module.exports = __webpack_public_path__ + "img/logo.daae1e33.png";